import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ViewRoot, ViewContentTwo } from '../../layout/Main/styled';
import { saveCurrentStep } from '../../features/stepper/stepper-slice';
import ContentPaymentBlockedOverSchedule from '../../components/molecules/ContentPaymentBlockedOverSchedule';

const PaymentBlocked = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(saveCurrentStep('paymentBloked'));
  }, []);
  return (
    <>
      <ViewRoot>
        <ViewContentTwo className="ViewContent">
          <ContentPaymentBlockedOverSchedule />
        </ViewContentTwo>
      </ViewRoot>
    </>
  );
};

export default PaymentBlocked;
